import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
} from '@angular/core';
// import { BkApi} from '@app/core/interfaces/interfaces';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MatchService} from '../services/match.service';

@Component({
    selector: 'sp-broadcasts-modal',
    templateUrl: '../templates/match-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MatchService],
})
export class MatchModalComponent implements OnInit {
    isLoad: boolean = true;
     cnt$!: Observable<any>;
    constructor(
        public mr: BsModalRef,
        private ms: MatchService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.cnt$ = this.ms.bkRedir().pipe(
            map((res) => {
                res.items.map((bk: any, ind: number) => {
                    bk.promo === null ? res.items.splice(ind, 1) : null;
                });
                res.items.map((bk: any) => {
                    bk.promo = [bk.promo[this.getRamdomIndx(bk.promo.length)]];
                });
                console.log(res)
                return res;
            })
        );
    }

    closeModal() {
        this.mr.hide();
    }

    getRamdomIndx(length: number) {
        return Math.floor(Math.random() * length);
    }
}
